import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import RightViewLayout from "../../components/RighViewLayout";
import CustomInput from "../../components/CustomInput";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  getMenus,
  getRoleById,
  updateRole,
} from "../../services/UserManagementService";
import { REACT_AUTHORIZATION_LEVEL } from "../../router/ReactEndPoints";
import { useSnackbar } from "notistack";
import CommonUtil from "../../util/CommonUtils";
import { handleCheckboxChange } from "./checkBox.js";
export default function EidtAuthorizationLevel() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [menus, setMenus] = useState([]);

  const [payload, setPayload] = useState({
    id: "",
    name: "",
    code: "",
    permissionIds: [],
  });

  const [error, setError] = useState({
    name: "",
    code: "",
    permissionIds: "",
  });

  useEffect(() => {
    getRoleById(state?.id).then((res) => {
      if (res?.data?.code == "LVLI0000") {
        const list = res?.data?.data?.permissionIdList
        setSelectedPermissions(list);
        setPayload({
          ...payload,
          ...res?.data?.data,
        });
      }
    });
  }, []);

  const loadData = () => {
    getMenus().then((res) => {
      if (res?.data?.code == "LVLI0000") {
        setMenus(res?.data?.data);
      }
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });

    setError({
      ...error,
      [name]: "",
      common: "",
    });
  };

  const changeFun = (values, isParent, type) => {
    handleCheckboxChange(menus, setSelectedPermissions, values, isParent, type);
  };



  useEffect(() => {
    setPayload({
      ...payload,
      permissionIds: selectedPermissions,
    })
  }, [selectedPermissions])

  const validateForm = () => {
    if (CommonUtil.isEmptyString(payload.name)) {
      enqueueSnackbar(t("tips_authorization.requires_name"), {
        variant: "error",
      });
      return;
    }
    if (CommonUtil.isEmpty(payload.permissionIds)) {
      enqueueSnackbar(t("tips_authorization.requires_permission"), {
        variant: "error",
      });
      return;
    }
    return true;
  };



  const handleSubmit = () => {
    if (validateForm()) {
      let parmas = {
        ...payload,
        permissionIds: selectedPermissions,
      };
      updateRole(state?.id, parmas).then((res) => {
        if (res?.data?.code == "LVLI0003") {
          enqueueSnackbar(t("tips_authorization.updated"), {
            variant: "success",
          });
          navigate(REACT_AUTHORIZATION_LEVEL);
        }
        if (res?.data?.code !== "LVLI0003") {
          enqueueSnackbar(res.data.message, { variant: "error" });
          return;
        }
      });
    }
  };




  return (
    <RightViewLayout
      title={t("authorization.edit")}
      navigateBack={REACT_AUTHORIZATION_LEVEL}>
      <Box pr={2}>
        <Grid>
          <Card
            elevation={0}
            sx={{
              background: " #FFFFFF 0% 0% no-repeat padding-box",
              fontWeight: "bold",
              opacity: 1,
              borderRadius: "8px",
            }}>
            <CardContent style={{ width: "30%" }}>
              <CustomInput
                resetError={() => setError({ ...error, name: "" })}
                disabled
                required
                error={error.name}
                label={t("authorization.name")}
                size="small"
                name="name"
                value={payload.name}
                handleChange={handleChange}
                inputProps={{
                  maxLength: 50,
                }}
                helperText={error.name}
                validation="alpha-numeric-ch-th"
              />
            </CardContent>
          </Card>
        </Grid>
        <Typography
          pt={1}
          pl={0}
          sx={{
            textAlign: "left",
            font: "normal normal medium 16px/22px Roboto",
            fontWeight: "bold",
            letterSpacing: "0px",
            opacity: "0.8",
          }}>
          {t("authorization.list")}
        </Typography>
        {menus?.map((menu) => {
          return (
            <Grid key={menu.id} pt={1.5}>
              <Card
                elevation={0}
                sx={{
                  background: "#FFFFFF 0% 0% no-repeat padding-box",
                  fontWeight: "bold",
                  borderRadius: "8px",
                }}>
                <FormGroup
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    ml: 4, // 设置左边距
                  }}>
                  <Grid lg={2}>
                    <FormControlLabel
                      key={menu.id}
                      control={
                        <Checkbox
                          id={`permission-checkbox-${menu.id}`}
                          checked={selectedPermissions?.includes(menu.id)}
                          onChange={() => changeFun(menu.id, null, "1")}
                        />
                      }
                      label={menu.name}
                      sx={{
                        textAlign: "left",
                        font: "normal normal medium 28px/38px Roboto",
                        fontWeight: "bold",
                        letterSpacing: "0px",
                        color: "#474B4F",
                      }}
                    />
                  </Grid>
                </FormGroup>

                <CardContent>
                  {menu?.menuItemList?.map((item) => (
                    <Grid
                      key={item.id}
                      sx={{
                        textAlign: "left",
                        font: "normal normal medium 32px/38px Roboto",
                        letterSpacing: "0px",
                        color: "#474B4F",
                      }}>
                      <FormGroup
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          ml: 6, // 设置左边距
                        }}>
                        <Grid lg={2}>
                          {item.name !== null ? (
                            <FormControlLabel
                              key={item.id}
                              control={
                                <Checkbox
                                  id={`permission-checkbox-${item.id}`}
                                  checked={selectedPermissions?.includes(
                                    item.id
                                  )}
                                  onChange={() =>
                                    changeFun(item.id, menu.id, "2")
                                  }
                                />
                              }
                              label={item.name}
                              sx={{
                                textAlign: "left",
                                font: "normal normal medium 18px/24px Roboto",
                                fontWeight: "bold",
                                letterSpacing: "0px",

                                color: "#474B4F",
                              }}
                            />
                          ) : null}
                        </Grid>
                      </FormGroup>

                      <FormGroup
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          ml: 12,
                        }}>
                        {item?.permissionList.map((permission) => (
                          <Grid lg={2}>
                            <FormControlLabel
                              key={permission.id}
                              control={
                                <Checkbox
                                  id={`permission-checkbox-${permission.id}`}
                                  checked={selectedPermissions?.includes(
                                    permission.id
                                  )}
                                  onChange={() =>
                                    changeFun(permission.id, item.id, "3")
                                  }
                                />
                              }
                              label={permission.name}
                              sx={{
                                width: 200,
                                mt: 1,
                              }}
                            />
                          </Grid>
                        ))}
                      </FormGroup>
                    </Grid>
                  ))}
                </CardContent>
              </Card>
            </Grid>
          );
        })}
        <Grid container spacing={2} pb={2} paddingBottom={"15px"} mt={2}>
          <Grid item xs={12}>
            <Box display={"flex"} flexDirection={"row-reverse"}>
              <Box item pl={2}>
                <Button
                  id="AddAuthorizationLevel-button-01"
                  variant="contained"
                  size="large"
                  className="text-transform-none"
                  onClick={handleSubmit}
                  style={{
                    size: "medium",
                    borderRadius: "8px",
                    opacity: 1,
                    background:
                      "transparent linear-gradient(270deg, #1487CA 0%, #78BC27 100%) 0% 0% no-repeat padding-box",
                  }}>
                  {t("common.save")}
                </Button>
              </Box>
              <Box item>
                <Button
                  id="AddAuthorizationLevel-button-02"
                  className="text-transform-none"
                  variant="outlined"
                  onClick={() => navigate(REACT_AUTHORIZATION_LEVEL)}
                  size="large">
                  {t("common.back")}
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </RightViewLayout>
  );
}
